import React, { FC, useState } from 'react'
import { IonModal, IonContent, IonFooter, IonSlides, IonSlide } from '@ionic/react'
import { observer } from 'mobx-react'
import { cartMobx, discountMobx } from 'restaurant'
import { cartMobx as MallcartMobx, discountMobx as MallDiscountMobx } from '@mobx/mall'
import { format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { get } from '@dt/fe-utils/dist/lodash'
import { ModalHeader } from '@cps'
import { SingleCouponsModal } from '../../modal'
import CouponList from './CouponList'
import './index.scss'

interface IProps {
  type?: string;
  reject?: any;
  resolve?: any;
  tabsType?: string;
}

const CounponModal: FC<IProps> = ({ tabsType, type, reject = () => { }, resolve = () => {} }) => {
  const counponType = ['single', 'all', tabsType !== 'noPromoCode' && 'promoCode'].filter(Boolean)
  // const counponType = ['single', 'all', 'promoCode'].filter(Boolean)

  const [curSlide, setCurSlide] = useState(0)
  // const [modalPromoCodeCoupons, setModalPromoCodeCoupons] = useState(discountMobx.promoCodeCoupons)
  const slideOpts = {
    initialSlide: curSlide,
    speed: 400
  }

  const CartMobx = type === 'mall' ? MallcartMobx : cartMobx
  const DiscountMobx = type === 'mall' ? MallDiscountMobx : discountMobx

  return (
    <IonModal
      isOpen
      cssClass='coupon-modal tall-modal'
      onDidPresent={() => {
        (document.getElementById('couponSlider') as any)?.update?.()
      }}
    >
      <ModalHeader title={i18n.t('cart.chooseCoupon')} onClose={reject} />
      <IonContent scrollX={false} scrollY={false}>
        <div className='coupon-content-box'>
          <div className='coupon-type-wrap'>
            <div className='coupon-type-list'>
              {
                counponType.map((type: string, index: number) => {
                  return (
                    <div
                      key={type}
                      className={`coupon-type-item${index === curSlide ? ' choosed' : ''}`}
                      data-cypid={`couponModal_${index}`}
                      onClick={() => {
                        if (curSlide !== index) {
                          (document.getElementById('couponSlider') as any).slideTo(index, 0)
                        }
                      }}
                    >
                      {type === 'promoCode' ? i18n.t('cart.promoCode') : i18n.t(`cart.${type}Coupon`)}
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className='coupon-sliders'>
            <IonSlides
              id='couponSlider'
              onIonSlideDidChange={(e: any) => {
                setCurSlide(e.target.swiper.activeIndex)
              }}
              options={slideOpts}
            >
              <IonSlide>
                <CouponList
                  coupons={Object.values(DiscountMobx.discountResult.memberItemCouponMap)}
                  isSingle={curSlide === 0}
                  selectItemCouponMap={DiscountMobx.discountAction.selectItemCouponMap}
                  onUseClick={(coupon) => {
                    const currentSelectPK = get(DiscountMobx.discountAction.selectItemCouponMap, `${coupon?.memberCouponId}`)
                    const canSelectPK = get(coupon.canUseProductPk, '0')
                    if (coupon.canUseProductPk?.length > 1) {
                      modalLayer(SingleCouponsModal, { data: coupon, type }, 'SingleCouponsModal')
                        .then(() => { })
                        .catch(() => { })
                    } else if (coupon.canUseProductPk?.length === 1) {
                      DiscountMobx.selectSingleProductCoupon((currentSelectPK === canSelectPK) ? (`${coupon?.memberCouponId}`) : { [coupon?.memberCouponId as number]: canSelectPK }, coupon.status === 'mutex')
                      // DiscountMobx.selectSingleProductCoupon((currentSelectPK === canSelectPK) ? (`${coupon?.memberCouponId}`) : { ...DiscountMobx.discountAction.selectItemCouponMap, [coupon?.memberCouponId as number]: canSelectPK })
                    }
                  }}
                />
              </IonSlide>
              <IonSlide>
                <CouponList
                  coupons={Object.values(DiscountMobx.wholeCoupons)}
                  onUseClick={(coupon) => DiscountMobx.selectCoupon(coupon)}
                />
              </IonSlide>
              {/* <IonSlide>
                <CouponList
                  coupons={DiscountMobx.promoCodeCoupons.map(coupon => {
                    if (coupon.status === 'disable') {
                      return { ...coupon, reason: i18n.t('checkout.promocode_not_optimal') }
                    }
                    return coupon
                  })}
                  isDelete
                  isPromoCode
                  onUseClick={(coupon) => {
                    confirmLayer({
                      children: i18n.t('common.confrim_whether_cancel')
                    }).then(() => {
                      const exitCodes = DiscountMobx.discountAction.promoCodes
                      DiscountMobx.setPromoCodes(exitCodes.filter(v => v !== coupon.promoCode))
                    }, () => {})
                    // DiscountMobx.selectPromoCode(coupon.promoCode)
                    // // 处理页面的选中
                    // setModalPromoCodeCoupons(modalPromoCodeCoupons.map(promoCodeCoupon => {
                    //   return {
                    //     ...promoCodeCoupon,
                    //     isSelect: DiscountMobx.discountAction.promoCodes.includes(promoCodeCoupon.promoCode)
                    //   }
                    // }))
                  }}
                />
              </IonSlide> */}
            </IonSlides>
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <div className='coupon-footer'>
          <div className='coupon-price'>
            <p>{i18n.t('cart.useDiscountCount', { count: DiscountMobx.usedCouponCnt })}</p>
            <p>{i18n.t('cart.discount')}{format.toPrice(CartMobx.cartResult.discountCouponPrice + CartMobx.cartResult.discountItemCouponPrice)}</p>
          </div>
          <div className='certain-btn' data-cypid='couponModalConfirm' onClick={() => resolve()}>{i18n.t('common.ok')}</div>
        </div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(CounponModal)
